import { ProductsFilter } from './ProductsFilter/ProductsFilter';

export function MobileProductsFilter() {
  return (
    <form className='mt-4 border-t border-gray-200 p-4'>
      <h3 className='sr-only'>Categories</h3>
      <ProductsFilter isMobile={true} />
    </form>
  );
}
